import { render, staticRenderFns } from "./APS.vue?vue&type=template&id=0c22d91e&scoped=true&"
import script from "./APS.vue?vue&type=script&lang=js&"
export * from "./APS.vue?vue&type=script&lang=js&"
import style0 from "./APS.vue?vue&type=style&index=0&id=0c22d91e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c22d91e",
  null
  
)

export default component.exports